import { TileLayer } from '@deck.gl/geo-layers/typed';
import { BitmapLayer } from '@deck.gl/layers/typed';
import { getTileSublayerBbox } from 'app/helpers';
import { useAppSelector } from 'app/store/store';
import { useEffect, useState } from 'react';
import { useLazyGetWindBarbsQuery, useLazyGetWindImageQuery } from 'app/api/weather';

import * as ParticleDeckGl from 'deck.gl-particle';

export const useLayerWind = (isWeatherLayerHiddenMode) => {
  const [getWind] = useLazyGetWindBarbsQuery();
  const [getWindImage] = useLazyGetWindImageQuery();

  const visible = useAppSelector((state) => state.weatherSlice.layersVisibility.wind);
  const user = useAppSelector((state) => state.userSlice.user);

  const [windImage, setWindImage] = useState();

  useEffect(() => {
    if (visible.particles) {
      getWindImage().then((res) => {
        const objectURL = URL.createObjectURL(res.data);
        setWindImage(objectURL);
      });
    }
  }, [visible]);
  const tileLayer = new TileLayer({
    data: null,
    id: 'layer-wind',

    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,
    visible: visible.barb && !isWeatherLayerHiddenMode,
    getTileData: (tile) => {
      const { south, west, east, north } = tile.bbox;
      const { signal } = tile;
      if (signal.aborted || !user || !visible?.barb) {
        return null;
      } else {
        const bbox = {
          first: { latitude: south, longitude: west },
          second: { latitude: north, longitude: east },
          z: 1,
        };

        return getWind({ bbox, width: 256, height: 256 });
      }
    },
    maxRequests: 1,
    renderSubLayers: (props) => {
      const bounds = getTileSublayerBbox(props.tile);
      const objectURL = URL.createObjectURL(props?.data?.data);
      const img = objectURL;

      const bitmapl = new BitmapLayer(props, {
        id: `bitmap-wind-tile-${props.tile.id}`,
        data: undefined,
        image: props?.data?.data?.type === 'image/png' ? img : null,
        bounds,
        transparentColor: [21, 14, 25, 15],
        visible: Boolean(img) && visible && !isWeatherLayerHiddenMode,
      });

      return bitmapl;
    },
  });

  useEffect(() => {
    if (user && visible.barb) {
      getWind({ width: 256, height: 256 });
    }
  }, [user, visible.barb]);

  const windLayer = new ParticleDeckGl.ParticleLayer({
    id: 'particle',
    visible: visible.particles && !isWeatherLayerHiddenMode,

    image: windImage || null,
    imageUnscale: [-128, 127],
    bounds: [-180, -90, 180, 90],
    numParticles: 1500,
    opacity: 0.4,
  });

  return visible.barb ? tileLayer : visible.particles ? windLayer : null;
};
